module.exports = __webpack_public_path__ + "img/14.4152f13f.png";